'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = exports.hasSeenCookiePolicy = exports.KEY_NAME = undefined;

var _localStorage = require('redux/saga/helpers/local-storage');

var KEY_NAME = exports.KEY_NAME = 'cpCookiePolicySeen';

var hasSeenCookiePolicy = exports.hasSeenCookiePolicy = function hasSeenCookiePolicy() {
  return (0, _localStorage.readLocalStorage)(KEY_NAME, false);
};

var set = exports.set = function set() {
  var seen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return (0, _localStorage.writeLocalStorage)(KEY_NAME, seen);
};